import { useEffect } from 'react';
import { useSelector } from '@lingoda/hooks';
import {
    goTo,
    postCheckoutCongratulationsPath,
    postCheckoutPath,
    studentHomePath,
    useRouteMatcher,
} from '@lingoda/router';
import { studentOnboardedSelector } from '@lingoda/students';

/**
 * This hook is used to redirect User to home page if he is already onboarded.
 **/
export const useRedirectToHomeIfShouldNotBeOnboarded = () => {
    const isOnboarded = useSelector(studentOnboardedSelector);
    const isAnyPostCheckoutRoute = useRouteMatcher([
        { path: postCheckoutPath(), matchPrefix: true },
    ]);
    const isPostCheckoutCongratulationsRoute = useRouteMatcher(postCheckoutCongratulationsPath());

    useEffect(() => {
        if (isOnboarded && isAnyPostCheckoutRoute && !isPostCheckoutCongratulationsRoute) {
            goTo(studentHomePath());
        }
    }, [isOnboarded, isAnyPostCheckoutRoute, isPostCheckoutCongratulationsRoute]);
};
